import React, { Component } from 'react';
import './Dashboard.scss';
import { Route, Routes, Navigate } from 'react-router-dom';

import DrawerNew from './DrawerNew';
import PermissionRouteBoundary from './PermissionRouteBoundary';
import DashboardView from 'Containers/General/DashboardView';
import { Actions, screenTypes } from 'Constants/permissions';

// Special routes
import CompanyList from 'Containers/Company/CompanyList';
import CompanyBillingDetails from 'Containers/Company/CompanyBillingDetails';
import CompanyTabs from 'Containers/Company/CompanyTabs';
import CompanySecondaryDetailsList from 'Containers/Company/CompanySecondaryDetailsList';
import CompanySecondaryDetails from 'Containers/Company/CompanySecondaryDetails';
import CompanyJsonConfigList from 'Containers/Company/CompanyJsonConfigList';
import CompanyJsonConfigPage from 'Containers/Company/CompanyJsonConfigPage';
import MenuList from 'Containers/Menu/MenuList';
import TicketList from 'Containers/Ticket/TicketList';
import TicketTabs from 'Containers/Ticket/TicketTabs';
import UserAdd from 'Containers/User/UserAdd';
import UsersList from 'Containers/User/UsersList';
import ExpenseTypeList from 'Containers/Expenses/ExpenseTypeList';
import ExpenseTypeAdd from 'Containers/Expenses/ExpenseTypeAdd';
import ExpenseList from 'Containers/Expenses/ExpenseList';
import ExpenseAdd from 'Containers/Expenses/ExpenseAdd';
import PermissionsPageNew from 'Containers/GroupsPermissions/PermissionsPageNew';
import PermissionsSyncPage from 'Containers/GroupsPermissions/PermissionsSyncPage';
import AgreementPreviewPage from 'Containers/Agreement/PreviewPage';
import CompanyInvoice from 'Containers/Billing/CompanyInvoice';
import TaskBacklogUnassigned from 'Containers/Task/TaskBacklogUnassigned';
import QuotationList from 'Containers/Quotation/QuotationList';
import QuotationAdd from 'Containers/Quotation/QuotationAdd';
import QuotationPreview from 'Containers/Quotation/QuotationPreview';
import SalesDashboard from 'Containers/SalesTracking/SalesDashboard';
import VisitsPage from 'Containers/SalesTracking/VisitsPage';
import VisitList from 'Containers/BasicDetails/VisitList';
import PersonsPage from 'Containers/SalesTracking/PersonsPage';

import VisitsMap from 'Containers/SalesTracking/VisitsMap';
import TaskDashboard from 'Containers/Task/TaskManagementDashboard';
import VisitPlanner from 'Containers/SalesTracking/VisitPlanner';
import UnplannedMap from 'Containers/SalesTracking/UnplannedMap';
import SalesTrack from 'Containers/SalesTracking/SalesTrack';
import SchoolCollegeSync from 'Components/AreaSearch/SchoolCollegeSync';

class DashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlHeaderMap: {},
      menu: [],
    };
  }

  // ✅ FIXED: React Router v6 compatible
  generateRoutesFromPermissions() {
    const routes = [];
    const processedUrls = new Set();
    const { props } = this;

    Object.keys(Actions).forEach(actionKey => {
      const action = Actions[actionKey];

      screenTypes.forEach(screenType => {
        const screenAction = action[screenType];

        if (screenAction && screenAction.url && screenAction.component) {
          const url = screenAction.url;

          if (processedUrls.has(url)) return;
          processedUrls.add(url);

          const Component = screenAction.component.type;

          routes.push(
            <Route
              key={`${actionKey}-${screenType}-${url}`}
              path={url}
              element={<Component {...props} />}
            />
          );

          // Associated URLs
          if (screenAction.associated_urls) {
            screenAction.associated_urls.forEach(associatedUrl => {
              if (!processedUrls.has(associatedUrl)) {
                processedUrls.add(associatedUrl);

                const associatedAction = action.create || action.view;

                if (associatedAction && associatedAction.component) {
                  const AssociatedComponent = associatedAction.component.type;

                  routes.push(
                    <Route
                      key={`${actionKey}-associated-${associatedUrl}`}
                      path={associatedUrl}
                      element={<AssociatedComponent {...props} />}
                    />
                  );
                }
              }
            });
          }
        }
      });
    });

    return routes;
  }

  render() {
    const { props } = this;
    const permissionRoutes = this.generateRoutesFromPermissions();

    return (
      <div className="dashboard-app">
        <DrawerNew {...props}>
          <Routes>
            <Route element={<PermissionRouteBoundary />}>

              {/* Special routes */}
              <Route path='/dashboard' element={<DashboardView {...props} />} />
              <Route path='/company/list' element={<CompanyList {...props} />} />
              <Route path='/company/details/:companyId' element={<CompanyBillingDetails {...props} />} />
              <Route path='/company/add' element={<CompanyTabs {...props} />} />
              <Route path='/company/edit' element={<CompanyTabs {...props} />} />

              <Route path='/companysecondarydetails/list' element={<CompanySecondaryDetailsList {...props} />} />
              <Route path='/companysecondarydetails' element={<CompanySecondaryDetails {...props} />} />

              <Route path='/company-json-config/list' element={<CompanyJsonConfigList {...props} />} />
              <Route path='/company-json-config' element={<CompanyJsonConfigPage {...props} />} />

              <Route path='/menu/list' element={<MenuList {...props} />} />
              <Route path='/service/list' element={<DashboardView {...props} />} />

              <Route path='/ticket/detail' element={<TicketTabs {...props} />} />
              <Route path='/ticket/list' element={<TicketList {...props} />} />

              {/* Redirect */}
              <Route path='/ticket/list/:companyId' element={<Navigate to='/ticket/list' />} />

              {/* Params handled inside component using useParams */}
              <Route path='/ticket/list/:companyId/detail' element={<TicketTabs {...props} />} />

              <Route path='/user/list' element={<UsersList {...props} />} />
              <Route path='/user/add' element={<UserAdd {...props} />} />

              <Route path='/permission/list' element={<PermissionsPageNew {...props} />} />
              <Route path='/permissions' element={<PermissionsSyncPage {...props} />} />

              <Route path='/expenses/expense-type/list' element={<ExpenseTypeList {...props} />} />
              <Route path='/expenses/expense-type/add' element={<ExpenseTypeAdd {...props} />} />
              <Route path='/expenses/expense/list' element={<ExpenseList {...props} />} />
              <Route path='/expenses/expense/add' element={<ExpenseAdd {...props} />} />

              {/* Agreement */}
              <Route
                path='/agreement/edit'
                element={
                  (() => {
                    const agreementAction = Actions.agreement;
                    if (agreementAction?.create?.component) {
                      const AgreementComponent = agreementAction.create.component.type;
                      return <AgreementComponent {...props} />;
                    }
                    return null;
                  })()
                }
              />

              <Route path='/agreement/preview' element={<AgreementPreviewPage {...props} />} />
              <Route path='/billing/issue-invoice/tax-invoice' element={<CompanyInvoice {...props} />} />
              <Route path='/task/backlog/unassigned' element={<TaskBacklogUnassigned {...props} />} />
              <Route path='/task/dashboard' element={<TaskDashboard {...props} />} />

              <Route path='/quotation/list' element={<QuotationList {...props} />} />
              <Route path='/quotation/add' element={<QuotationAdd {...props} />} />
              <Route path='/quotation/preview' element={<QuotationPreview {...props} />} />
              <Route path='/sales-dashboard' element={<SalesDashboard {...props} />} />
              <Route path='/sales/visits' element={<VisitsPage {...props} />} />
              <Route path='/sales/my-visits' element={<VisitsPage {...props} />} />
              <Route path='/sales/track' element={<SalesTrack {...props} />} />
              <Route path='/sales/my-track' element={<SalesTrack {...props} />} />
              <Route path='/sales/visit-planner' element={<VisitPlanner {...props} />} />
              <Route path='/sales/unplanned' element={<UnplannedMap {...props} />} />
              <Route path='/sales/persons' element={<PersonsPage {...props} />} />
              <Route path='/sales/visits-map' element={<VisitsMap {...props} />} />
              <Route path='/area-search' element={<SchoolCollegeSync />} />
              <Route path='/sales/visit-planner' element={<VisitPlanner {...props} />} />


              {/* Redirects */}
              <Route path='/agreement/form' element={<Navigate to='/agreement/add' />} />
              <Route path='/agreement/view' element={<Navigate to='/agreement/list' />} />

              {/* Dynamic routes */}
              {permissionRoutes}

            </Route>
          </Routes>
        </DrawerNew>
      </div>
    );
  }
}

export default DashBoard;